import { forwardRef } from 'react'
import { useState } from 'react'

import Lightbox from '@/organisms/Lightbox'
import Product from '@/ts/Product'

import Image from './includes/Image'
import Navigation from './includes/Navigation'

const Presentation = forwardRef<HTMLDivElement, GalleryPresentationProps>(
  (props, ref) => {
    const [lightbox, setLightbox] = useState(false)

    const { product, currentSlide, onChange } = props
    const { images, name } = product

    return (
      <>
        <div
          ref={ref}
          className="relative flex flex-col w-full min-h-full space-y-4"
        >
          <div className="relative min-h-full px-4 2sm:px-8">
            <Image
              src={images[currentSlide]?.src}
              title={name}
              onClick={() => setLightbox(true)}
            />
          </div>
          <Navigation
            currentSlide={currentSlide}
            totalImages={images.length}
            onClick={onChange}
          />
        </div>
        {lightbox && (
          <Lightbox
            initialImage={currentSlide}
            images={images.map(({ src }) => src)}
            onExit={() => setLightbox(false)}
          />
        )}
      </>
    )
  }
)

interface GalleryPresentationProps {
  product: Product
  currentSlide: number
  onChange(index: number): void
}

export default Presentation
